export const GET_MY_INVOICES_PENDING = 'GET_MY_INVOICES_PENDING'
export const GET_MY_INVOICES_SUCCESSFUL = 'GET_MY_INVOICES_SUCCESSFUL'
export const GET_MY_INVOICES_ERROR = 'GET_MY_INVOICES_ERROR'